<template>
  <div>
    <template v-if="travelService !== null">
      <OrderDetailsForOrderItem :data="travelService" />
      <OrderItemParameters :type="travelService.orderItem.type" :order-item="travelService.orderItem" />
      <template v-if="travelService.selected_offer !== null">
        <fieldset
          class="custom-fieldset"
          :class="{
            'fieldset-warning': travelService.orderItem.status === itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL,
            'fieldset-error': travelService.orderItem.status === itemsStatus.STATUS_BOOKING_CANCELLED
          }"
        >
          <legend>
            {{ $t("travelService.chooseOfferForm.service") }} -
            {{ $t("travelService.types." + travelService.orderItem.type) }}
            <template v-if="travelService.orderItem.status === itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL">
              ({{ $t("travelService.singleServiceOrderStatus.requestBookingCancel") }})
            </template>
            <template v-if="travelService.orderItem.status === itemsStatus.STATUS_BOOKING_CANCELLED">
              ({{ $t("travelService.singleServiceOrderStatus.bookingCanceled") }})
            </template>
          </legend>
          <v-row>
            <v-col md="10" v-if="travelService.selected_offer.html != null && travelService.selected_offer.html.length !== 0">
              <w-y-s-i-w-y-g-html-element :html="travelService.selected_offer.html" />
            </v-col>
            <v-col
              md="10"
              v-if="travelService.orderItem.type === 'hotel' && (travelService.selected_offer.html == null || travelService.selected_offer.html.length === 0)"
              cols="12"
            >
              <hotel-response-presentation :offer="travelService.selected_offer" />
            </v-col>
            <v-col
              md="10"
              v-if="travelService.orderItem.type === 'car' && (travelService.selected_offer.html == null || travelService.selected_offer.html.length === 0)"
              cols="12"
            >
              <car-response-presentation :offer="travelService.selected_offer" />
            </v-col>
            <v-col
              md="10"
              v-if="travelService.orderItem.type === 'flight' && (travelService.selected_offer.html == null || travelService.selected_offer.html.length === 0)"
              cols="12"
            >
              <flight-response-presentation :offer="travelService.selected_offer" />
            </v-col>
            <v-col
              md="10"
              v-if="travelService.orderItem.type === 'rail' && (travelService.selected_offer.html == null || travelService.selected_offer.html.length === 0)"
              cols="12"
            >
              <rail-response-presentation :offer="travelService.selected_offer" />
            </v-col>
            <v-col class="pl-3" md="2" cols="12">
              <v-text-field
                :label="$t('global.amount')"
                :value="travelService.selected_offer.price + ' ' + travelService.selected_offer.currency"
                outlined
                readonly
              />
              <div class="text-center my-3" style="width: 100%">
                <v-icon color="primary" style="font-size: 100px">{{ bookingIconType(travelService.orderItem.type) }}</v-icon>
              </div>
            </v-col>
          </v-row>
        </fieldset>
      </template>
      <v-alert :value="travelService.status === serviceStatus.STATUS_SEND" outlined color="error darken-4">
        Zamówienie oczekuje na wybór z dostępnych ofert. Kliknij <a @click="$router.push('/travel-service/choose-offer/' + travelService.id)">tutaj</a> aby
        przejść do formularza wyboru.
      </v-alert>

      <template v-if="notSelectedResponses.length > 0">
        <h3>Lista ofert które nie zostały wybrane</h3>
        <span v-for="response of notSelectedResponses" :key="response.id">
          <offer-archive-dialog :type="travelService.orderItem.type" :id="response.id" :is-admin="false">
            {{ response.last_edit_at }} {{ response.last_edit_by_name }} <v-btn icon><v-icon>remove_red_eye</v-icon></v-btn>
          </offer-archive-dialog>
        </span>
      </template>

      <message-list
        class="mb-3"
        v-if="travelService.messages"
        :travel-service-order-id="travelService.id"
        :travel-service-order-item-id="travelService.orderItem.id"
        :start-messages="travelService.messages"
      />

      <template v-if="travelService.selected_offer !== null && travelService.selected_offer.history.length > 0">
        <h3>{{ $t("travelService.outdatedOffers") }}:</h3>
        <span v-for="historyItem of travelService.selected_offer.history" :key="historyItem.id">
          <offer-archive-dialog :type="travelService.orderItem.type" :id="historyItem.id" :is-admin="false">
            {{ historyItem.last_edit_at }} {{ historyItem.last_edit_by_name }} <v-btn icon><v-icon>remove_red_eye</v-icon></v-btn>
          </offer-archive-dialog>
        </span>
      </template>
    </template>
    <v-row>
      <v-spacer />
      <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import { settingTypes } from "../../staticData/SettingsTypes";
import OrderItemParameters from "../../components/TravelService/Admin/OrderItemParameters";
import OrderDetailsForOrderItem from "../../components/TravelService/OrderDetailsForOrderItem";
import MessageList from "../../components/MessageList";
import OfferArchiveDialog from "../../components/TravelService/OfferArchiveDialog";
import WYSIWYGHtmlElement from "../../components/Shared/WYSIWYGHtmlElement";
import HotelResponsePresentation from "../../components/TravelService/OfferPresentation/HotelResponsePresentation";
import CarResponsePresentation from "../../components/TravelService/OfferPresentation/CarResponsePresentation";
import FlightResponsePresentation from "../../components/TravelService/OfferPresentation/FlightResponsePresentation";
import RailResponsePresentation from "../../components/TravelService/OfferPresentation/RailResponsePresentation";
import { serviceStatus, itemsStatus, bookingIconType } from "../../staticData/ServiceOrder";

export default {
  name: "TravelServiceItemDetailsView",
  components: {
    RailResponsePresentation,
    FlightResponsePresentation,
    CarResponsePresentation,
    HotelResponsePresentation,
    WYSIWYGHtmlElement,
    OfferArchiveDialog,
    MessageList,
    OrderItemParameters,
    OrderDetailsForOrderItem
  },
  data: () => ({
    travelService: null,
    availableUsers: [],
    settingTypes,
    itemsStatus,
    serviceStatus
  }),
  created() {
    this.axios
      .get("/travel-service/get-service-order-item", {
        params: { id: this.$route.params.id }
      })
      .then(resp => {
        this.travelService = JSON.parse(JSON.stringify(resp.data));
      });
  },
  methods: {
    cancel() {
      this.$router.push("/travel-service");
    },
    bookingIconType
  },
  computed: {
    notSelectedResponses() {
      if (this.travelService !== null && this.travelService.selected_offer !== null) {
        return this.travelService.responses.filter(v => v.id !== this.travelService.selected_offer.id);
      }
      return [];
    }
  }
};
</script>

<style scoped></style>
